type CustomMapStyle = google.maps.MapTypeStyle;


export const mapStyleSheet: CustomMapStyle[] = [
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [{"visibility": "on"}]
  },
  {
    "featureType": "administrative",
    "elementType": "labels.text.stroke",
    "stylers": [{"visibility": "on"}]
  },
  {
    "featureType": "landscape.man_made",
    "elementType": "geometry.fill",
    "stylers": [{"color": "#e6e5e0"}]
  },
  {
    "featureType": "landscape.man_made",
    "elementType": "labels.text.fill",
    "stylers": [{"color": "#f2d073"}, {"visibility": "on"}]
  },
  {
    "featureType": "landscape.natural",
    "elementType": "geometry.fill",
    "stylers": [{"color": "#92ceac"}]
  },
  {
    "featureType": "poi",
    "stylers": [{"visibility": "on"}]
  },
  {
    "featureType": "poi",
    "elementType": "geometry.fill",
    "stylers": [{"color": "#f8ecaf"}]
  },
  {
    "featureType": "poi.attraction",
    "elementType": "geometry.fill",
    "stylers": [{"color": "#ead699"}]
  },
  {
    "featureType": "poi.business",
    "elementType": "labels.icon",
    "stylers": [{"color": "#ead699"}]
  },
  {
    "featureType": "poi.medical",
    "elementType": "geometry.fill",
    "stylers": [{"color": "#ea99ae"}]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "on"}]
  },
  {
    "featureType": "road",
    "elementType": "labels.text.stroke",
    "stylers": [{"visibility": "on"}]
  },
  {
    "featureType": "transit",
    "stylers": [{"visibility": "on"}]
  },
  {
    "featureType": "water",
    "elementType": "geometry.fill",
    "stylers": [{"color": "#5fa6dd"}]
  }
];